/**
 * Precision Savings Comparison Component
 * Handles load more functionality for comparison rows
 */

function initPrecisionSavingsComparison() {
  const sections = document.querySelectorAll('.precision-savings-comparison[data-section-id]');

  sections.forEach((sectionEl) => {
    const sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    initLoadMoreButton(sectionEl, sectionId);
  });
}

function initLoadMoreButton(sectionEl, sectionId) {
  const loadMoreBtns = sectionEl.querySelectorAll(`.precision-savings-load-more-${sectionId}`);
  if (!loadMoreBtns.length) return;

  loadMoreBtns.forEach((loadMoreBtn) => {
    // Remove existing event listeners by cloning
    const newBtn = loadMoreBtn.cloneNode(true);
    loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);

    newBtn.addEventListener('click', function(e) {
      e.preventDefault();

      const isExpanded = this.classList.contains('is-expanded');

      // Get all hidden rows (rows with comparison-row-hidden class)
      const hiddenRows = sectionEl.querySelectorAll(`.comparison-row-${sectionId}.comparison-row-hidden`);

      // Toggle tw-hidden class on hidden rows
      hiddenRows.forEach((row) => {
        row.classList.toggle('tw-hidden', isExpanded);
      });

      // Toggle border on initial last row
      const initialLastRows = sectionEl.querySelectorAll(`.comparison-row-${sectionId}.comparison-row-initial-last`);
      initialLastRows.forEach((row) => {
        row.classList.toggle('!tw-border-b-0', isExpanded);
      });

      updateAllLoadMoreButtons(sectionEl, sectionId, !isExpanded);
    });
  });
}

function updateAllLoadMoreButtons(sectionEl, sectionId, isExpanded) {
  sectionEl.querySelectorAll(`.precision-savings-load-more-${sectionId}`).forEach((btn) => {
    // Toggle visibility of show-more and show-less elements
    const showMoreElements = btn.querySelectorAll('[data-show-more]');
    const showLessElements = btn.querySelectorAll('[data-show-less]');
    
    showMoreElements.forEach((el) => {
      el.classList.toggle('tw-hidden', isExpanded);
    });
    
    showLessElements.forEach((el) => {
      el.classList.toggle('tw-hidden', !isExpanded);
    });
    
    // Toggle expanded class
    btn.classList.toggle('is-expanded', isExpanded);
  });
}

export default initPrecisionSavingsComparison;
